import React, {Component} from 'react';

import ReactHighcharts from 'react-highcharts';

export default class ColumnChart extends Component {

    _getGraphConfig = () => {
        return {
            chart: {
                    type: 'column',
                    height:234,
                    width:220
                },
                title: {
                    text: ''
                },
                xAxis: {
                 gridLineWidth: 0,
                 minorGridLineWidth: 0,
                  categories: [
                     'Comportamiento últimos 2 trimetres',
                     `Últimos 6 trimestres país`,
                    ],
                    labels:{
                        enabled:true
                    }
                },
                yAxis: {
                 gridLineWidth: 0,
                 minorGridLineWidth: 0,
                    min: 0,
                    labels:{
                    enabled:false},
                    title: {
                        text: ''
                    },
                    stackLabels: {
                        enabled: true,
                        style: {
                            color: 'gray'
                        }
                    }
                },
                legend: {
                    enabled:false
                },
                tooltip: {
                    pointFormat: '<tr><td style="color:{series.color};padding:0"><b>{series.name}: </b></td>' +
                                                  '<td style="padding:0"><b>{point.percentage:,.0f}%</b></td></tr>'
                },
                plotOptions: {
                    column: {
                        stacking: 'percent',
                         pointWidth: 20
                    }
                },
                credits:{
                    enabled:false
                },
                series: this.props.data
        };
    }


    render() {

        let graph_config = this._getGraphConfig();

        return (
            <div style={{marginTop:15}}>
                <ReactHighcharts config={graph_config}/>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/containers/dashboard-spl/pyramidPerSegment/components/columnChart/ColumnChart.js